export default __webpack_public_path__ + "static/media/robert-louis-stevenson.9c70b9cc.png";